export const domain = 'https://exoft.net';

export const openGraphImageUrl = `${domain}/logo-black.webp`;

export const recaptchaKey = '6LfyH4AUAAAAANeQRWBs99e4T2VL6xfMTNpykEQM';

export const socialLinks = {
    x: 'https://x.com/ExoftSoftware/',
    facebook: 'https://www.facebook.com/exoft/',
    linkedin: 'https://www.linkedin.com/company/exoft/',
    behance: 'https://www.behance.net/exoft/',
    clutch: 'https://clutch.co/profile/exoft',
    selectedfirms: 'https://selectedfirms.co/agency/exoft',
    techreviewer: 'https://techreviewer.co/companies/exoft/',
    softwareworld: 'https://www.softwareworld.co/service/exoft-reviews/',
    goodfirms: 'https://www.goodfirms.co/company/exoft/',
};
